import { useDispatch, useSelector } from "react-redux";
import "./fhsgraph.scss";
import { useState, useEffect, useRef } from "react";
import exportimages from "../../../../../../assets/images/exportImages";
import GaugeChart from "./GaugeChart";
import { setShowGaugeChart } from "../../../../../../rtk-query/features/dashboard/financialHealthScore/financialHealthScoreAnalysisSlice";
import { BPM_KEY, SUBSCRIPTION } from "../../../../../../utils/global";
import ForecastGraph from "./ForecastGraph";
import { getOrdinalSuffix } from "../../../../../../utils/Utils";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { usePermissions } from "../../../../../../hooks/usePermissions";
import { PRIVILEGES } from "../../../../../../utils/privileges";
import { useSubscription } from "../../../../../../hooks/useSubscription";
import CustomTooltip from "../../../../../Common/Tooltip/CustomTooltip";
import {
  setMode,
  setSelectedCohort,
} from "../../../../../../rtk-query/features/cohort/cohortSlice";
import { COHORT_MODE } from "../../../../Cohort/CohortList/CohortList";
import { Skeleton } from "primereact/skeleton";
import { setselectedCohortOnFHS } from "../../../../../../rtk-query/features/downloadFHSReport/downloadFHSReportSlice";
import { setFinalGuageUpdate, setGuageIsLoading } from "../../../../../../Redux/loaderSlice";

const FHSGraph = ({ cohortList }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  const orgReducer = useSelector((state) => state.orgReducer);
  const selectedbankMetrics = useSelector(
    (state) => state.infiniteBankPerformanceMetricsReducer,
  );
  let selectedFinancialTrend =
    selectedbankMetrics?.selectedBankMetricData?.financial_health_score;

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  const guageIsLoading = useSelector(
    (state) => state?.loaderReducer?.guageIsLoading,
  );

  useEffect(() => {
    return () => dispatch(setShowGaugeChart(false));
  }, []);

  // State to track whether FHSTrendGraph or FHSGauge is shown
  const [toggleButton, setToggleButton] = useState(true);

  const handleDropdownShow = () => {
    // allow panel to mount
    requestAnimationFrame(() => {
      const panel = document.querySelector(".cohort_details_custom_dropdown");
      if (!panel) return;

      const stopHoverScroll = (e) => {
        e.stopImmediatePropagation();
      };

      panel.addEventListener("mouseenter", stopHoverScroll, true);
      panel.addEventListener("mousemove", stopHoverScroll, true);
    });
  };

  return (
    <div className="d-flex flex-column rounded h-100">
      <div className="d-flex justify-content-between">
        <div className="flex-column justify-content-between">
          <div className="fw-bolder text-dark w-100 ms-1 fs-title mb-0">
            {/* Financial Health */}
            Financial Performance Benchmark
          </div>
          <span className="description fs-desc ms-1">
            Overall strength of your institution based on your financial
            performance.
          </span>
        </div>
        <div
          className="ms-10 pdf-visiblity"
          style={{ zIndex: 1, position: "sticky" }}
        >
          <div className="d-flex flex-row">
            <div
              className="toggle-gauge me-1"
              onClick={() => setToggleButton(!toggleButton)}
              style={{
                backgroundColor: !toggleButton ? "#FFF" : "#619BF3",
              }}
            >
              <img
                alt="icon"
                src={
                  !toggleButton
                    ? exportimages.gauge_blue
                    : exportimages.gauge_white
                }
              />
            </div>
            <div
              className="toggle-trend"
              onClick={() => setToggleButton(!toggleButton)}
              style={{
                backgroundColor: toggleButton ? "#FFF" : "#619BF3",
              }}
            >
              <img
                alt="icon"
                src={
                  toggleButton
                    ? exportimages.trend_blue
                    : exportimages.trend_white
                }
              />
            </div>
            {/* <div class="ms-2 cursor-pointer">
              <div
                className={`d-flex justify-content-left ${!downloadBtnStatus ? "disabledbuttonDownload" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  downloadReport();
                }}
              >
                <img
                  alt="icon"
                  src={exportimages?.downloadIcon}
                  style={{ height: "3rem" }}
                />
              </div>
            </div> */}
            {/* <div
              // className={`d-flex justify-content-left ms-2 cursor-pointer ${!downloadBtnStatus ? "disabledbuttonDownload" : ""}`}
              className={`d-flex justify-content-left ms-2 cursor-pointer`}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                downloadPdf();
              }}
            >
              <img
                alt="icon"
                src={exportimages?.downloadIcon}
                style={{ height: "3rem" }}
              />
            </div> */}
            {/* <PDFDownloadLink document={<MyDoc />} fileName="somename.pdf">
              {({ blob, url, loading, error }) =>
                loading ? "Loading document..." : "Download now!"
              }
            </PDFDownloadLink> */}
          </div>
        </div>
      </div>
      <div
        className="graph-container align-content-end position-relative"
        style={{ paddingTop: !toggleButton ? "0" : "2rem" }}
      >
        {toggleButton ? (
          <div
            className="FHSGuageChart"
            style={{ width: "60%", height: "60%" }}
          >
            {/* {selectedCohort?.cohortResult?.cohort_avg ? ( */}
            <GaugeChart
              showCohort={true}
              cohortAverageValue={selectedCohort?.cohortResult?.cohort_avg}
              graphHeight={67}
              graphPosition={["50%", "80%"]}
            />
            {/* ) : (
              <div className="mx-0 d-flex flex-column justify-content-between rounded h-100">
                <div className="guage-semicircle-container d-flex flex-column overflow-hidden m-0">
                  <div className="semicircle d-flex justify-content-center">
                    <Skeleton
                      shape="circle"
                      size="28rem"
                      className="skeleton-circle"
                      style={{ zIndex: -1 }}
                    />
                  </div>
                </div>
              </div>
            )} */}
          </div>
        ) : (
          <ForecastGraph
            forecastData={selectedFinancialTrend?.trend}
            type={BPM_KEY?.financial_health_score}
            showCohort={true}
            graphHeight={270}
          />
        )}

        {hasPermission(PRIVILEGES.VIEW_COHORT) && toggleButton && (
          <div className="cohortDetailsListContainer">
            <label>Cohort Details</label>

            <div className="position-relative">
              {selectedCohort?.cohortResult?.cohort_avg && !guageIsLoading ? (
                <Dropdown
                  value={selectedCohort}
                  onChange={(e) => {
                    // dispatch(setFinalGuageUpdate(false))
                    dispatch(setGuageIsLoading(true));
                    const _selectedCohort = e.value;
                    if (_selectedCohort?.cohortType === 1) {
                      dispatch(setMode(COHORT_MODE.SUGGESTED));
                    } else {
                      dispatch(setMode(COHORT_MODE.CUSTOM));
                    }
                    dispatch(setSelectedCohort(_selectedCohort));
                    dispatch(setselectedCohortOnFHS(_selectedCohort));
                  }}
                  options={cohortList || []}
                  optionLabel="name"
                  className="custom_dropdown"
                  panelClassName="cohort_details_custom_dropdown"
                  onShow={handleDropdownShow}
                />
              ) : (
                <div className="d-flex mb-4">
                  <Skeleton height="3rem" width="80%" className="me-2" />
                  <Skeleton height="3rem" width="20%" />
                </div>
              )}

              {hasPermission(PRIVILEGES.SHOW_COHORT_MANAGEMENT) && (
                <CustomTooltip text="Cohort" placement="top">
                  <button
                    type="button"
                    disabled={
                      !hasSubscription(PRIVILEGES.SHOW_COHORT_MANAGEMENT) ||
                      orgReducer?.selectedFI?.orgClientId === null
                    }
                    onClick={(e) => {
                      navigate(`/bank/cohort-management`);
                    }}
                    className="btn btn-link position-absolute top-0 end-0 p-0"
                  >
                    <img
                      src={exportimages?.cohortNavigationIcon}
                      className="img-fluid "
                    />
                  </button>
                </CustomTooltip>
              )}
            </div>

            {selectedCohort?.cohortResult?.cohort_avg && !guageIsLoading ? (
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <p className="mb-0 fs-14">Percentile</p>
                  <p className="mb-0 fs-14 fw-bolder">
                    {selectedCohort?.cohortResult?.percentile
                      ? `${selectedCohort?.cohortResult?.percentile}${getOrdinalSuffix(selectedCohort?.cohortResult?.percentile)}`
                      : "-"}
                  </p>
                </div>
                <div class="flex-shrink-0">
                  <img
                    src={exportimages?.cohort_percentile_icon}
                    className="img-fluid"
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex mb-4">
                <Skeleton height="3rem" width="80%" className="me-2" />
                <Skeleton height="3rem" width="20%" />
              </div>
            )}

            <hr />
            {selectedCohort?.cohortResult?.cohort_avg && !guageIsLoading ? (
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <p className="mb-0 fs-14">Cohort Average</p>
                  <p className="mb-0 fs-14 fw-bolder">
                    {selectedCohort?.cohortResult?.cohort_avg ?? "-"}
                  </p>
                </div>
                <div class="flex-shrink-0">
                  <img
                    src={exportimages?.cohort_avg_icon}
                    className="img-fluid"
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex mb-4">
                <Skeleton height="3rem" width="80%" className="me-2" />
                <Skeleton height="3rem" width="20%" />
              </div>
            )}

            <hr />
            {selectedCohort?.cohortResult?.cohort_avg && !guageIsLoading ? (
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <p className="mb-0 fs-14">Institutions</p>
                  <p className="mb-0 fs-14 fw-bolder">
                    {selectedCohort?.cohortResult?.institution_count ?? "-"}
                  </p>
                </div>
                <div class="flex-shrink-0">
                  <img
                    src={exportimages?.cohort_institution_count_icon}
                    className="img-fluid"
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex mb-4">
                <Skeleton height="3rem" width="80%" className="me-2" />
                <Skeleton height="3rem" width="20%" />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FHSGraph;
